export function stringToBoolean(val: string): boolean {
    if (val === 'true') {
        return true;
    } else if (val === 'false') {
        return false;
    }
    return false;
}
